import React from 'react'
import Countdown from '../../Widget/Countdown/Countdown'

import { getCountdownInfo } from '../../../utils/dateUtils'

import { rem as px2rem } from '../../../utils/remUtils'
import styles from './PromotionBar.module.css'

const DEFAULT_COUNTDOWN_THEME = {
  background: "#FFF",
  color: "#190808"
}

const DEFAULT_PROMOTION_SIZE = {
  width: 60,
  height: 375
}

const CountdownBar = ({ countdownInfo, countdownTheme, $i18n }) => {
  if (!countdownInfo) {
    return null
  }

  const countdownTextStyle = {
    color: countdownTheme.background
  }

  return (
    <div className={styles.countdownContainer}>
      {
        countdownInfo.days > 0 ?
        <div className={styles.countdownText} style={countdownTextStyle}>
          {$i18n.transl('core.promotion.endsIn')} {(countdownInfo.days + (countdownInfo.days > 1 ?  ` ${$i18n.transl('core.promotion.days')}` : ` ${$i18n.transl('core.promotion.day')}`))}
        </div>
        :
        <div />
      }
      <Countdown
        timestamp={countdownInfo.time}
        type={Countdown.TYPE.CLOCK}
        className={styles.countdown}
        {...countdownTheme}
      />
    </div>
  )
}

const PromotionBar = props => {
  const { promotion } = props

  if (!promotion) {
    return null
  }

  const { width, height, image, color, countdownTheme } = props

  if (!image) { // 没有配置商详促销标的均不展示
    return null
  }

  const style = {
    width: px2rem(width || DEFAULT_PROMOTION_SIZE.width),
    height: px2rem(height || DEFAULT_PROMOTION_SIZE.height),
    lineHeight: px2rem(height || DEFAULT_PROMOTION_SIZE.height),
  }

  if (image) {
    style.backgroundImage = `url(${image})`
    style.backgroundSize = '100%'
    style.backgroundColor = 'transparent'
  }

  if (color) {
    style.color = color
  }

  let endDate

  const countdown = props.countdown

  if (countdown) {
    endDate = new Date(promotion.userOptions.takenTime + countdown)
  } else {
    if (promotion.meta.clientEndDate) {
      endDate = new Date(promotion.meta.clientEndDate)
    }
  }

  return (
    <section className={styles.wrapper} style={style}>
      <CountdownBar
        $i18n={props.$i18n}
        countdownInfo={getCountdownInfo(endDate)}
        countdownTheme={countdownTheme || DEFAULT_COUNTDOWN_THEME}
      />
      {
        props.renderRibbon && (
          <div className={styles.ribbon}>{props.renderRibbon()}</div>
        )
      }
    </section>
  )
}

export default PromotionBar
